import React from "react";
import SectionTitle from "../../elements/section-title/SectionTitle";
import ProcesstData from "../../data/process/ProcessData.json";
import { FaCalendarAlt, FaHome, FaPenFancy } from "react-icons/fa";
import Tilty from "react-tilty";

const getProcesstData = ProcesstData;

// Processus simplifié en 3 étapes pour maximiser la conversion
const ProcessOne = () => {
  return (
    <div className="section section-padding">
      <div className="section-heading text-center mb--70">
        <h2 className="title">Comment ça marche ?</h2>
        <p className="subtitle" style={{ marginTop: '16px', fontSize: '18px', color: '#6b7280', maxWidth: '800px', margin: '16px auto 0' }}>
          Avec LocaJoy, vous confiez votre bien à des professionnels qui sécurisent vos revenus et prennent en charge chaque aspect de la location. Nous gérons tout : recherche du locataire, état des lieux, entretien, paiements...
        </p>
        <p style={{ marginTop: '12px', fontSize: '16px', color: '#111827', fontWeight: '500' }}>
          Vous profitez de vos revenus, sans perdre de temps.
        </p>
      </div>
      <div className="container">
        {getProcesstData.map((data) => {
          // Icônes optimisées pour 3 étapes
          const icons = {
            1: <FaCalendarAlt />,
            2: <FaHome />,
            3: <FaPenFancy />,
          };
          return (
            <div
              key={data.id}
              className="process-work"
            >
              <div className="thumbnail icon-circle" aria-hidden>
                {icons[data.id] || <FaCalendarAlt />}
              </div>
              <div className="content">
                <span className="subtitle">{data.subtitle}</span>
                <h3 className="title">{data.title}</h3>
                <p className="description">{data.paragraph}</p>
              </div>
            </div>
          );
        })}
        
        {/* Call-to-Action pour maximiser la conversion */}
        <div className="text-center" style={{ marginTop: '48px' }}>
          <a 
            href="/contact-1" 
            className="axil-btn btn-fill-primary btn-large"
            style={{ 
              padding: '16px 40px',
              fontSize: '16px',
              fontWeight: '600',
              borderRadius: '8px'
            }}
          >
            Contacter notre agent
          </a>
        </div>
      </div>
      {/* Conservez les formes décoratives existantes */}
      <ul className="shape-group-17 list-unstyled">
        {/* ... */}
      </ul>
    </div>
  );
};

export default ProcessOne;
